import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType, ReferenceRateBase, PayableOver, ReferenceRateUnit } from "__generated__/graphql";
import ReferenceRateCalculationMethodForm from "view/calculationmethods/components/form/ReferenceRateCalculationMethodForm";
import ReferenceRateCalculationMethodDetails from "view/calculationmethods/components/details/ReferenceRateCalculationMethodDetails";

export const ReferenceRateSchema: RegistryItem = {
	[CalculationMethodType.ReferenceRate]: {
		Form: ReferenceRateCalculationMethodForm,
		Details: ReferenceRateCalculationMethodDetails,
		fields: {
			"calculationMethod.referenceRateUnit": { path: "referenceRateUnit", rules: { required: true } },
			"calculationMethod.referenceRateBase": { path: "referenceRateBase", rules: { required: true } },
			"calculationMethod.route": {
				path: "route",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.referenceRateBase === ReferenceRateBase.Route,
				},
			},
			"calculationMethod.loadLocation": {
				path: "loadLocation",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.referenceRateBase === ReferenceRateBase.LoadLocation,
				},
			},
			"calculationMethod.dischargeLocation": {
				path: "dischargeLocation",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.referenceRateBase === ReferenceRateBase.DischargeLocation,
				},
			},
			"calculationMethod.adjustmentType": {
				path: "adjustmentType",
				rules: {
					required: true,
				},
			},
			"calculationMethod.adjustmentAmount": {
				path: "adjustmentAmount",
				rules: {
					required: true,
				},
			},
			"calculationMethod.preAgreed": {
				path: "preAgreed",
				rules: {
					requiredIf: ({ calculationMethod }) => calculationMethod?.payableOver === PayableOver.Preagreed,
				},
			},
		},
		toInput: (form) => ({
			referenceRateCalculationMethodInput: {
				id: form.id,
				referenceRateUnit: form.referenceRateUnit,
				referenceRateBase: form.referenceRateBase,
				referenceRateDateType: form.referenceRateDateType,
				preAgreed: form.payableOver === PayableOver.Preagreed ? form.preAgreed : undefined,
				route: form.referenceRateBase === ReferenceRateBase.Route ? form.route : undefined,
				loadLocation: form.referenceRateBase === ReferenceRateBase.LoadLocation ? form.loadLocation?.id : undefined,
				dischargeLocation: form.referenceRateBase === ReferenceRateBase.DischargeLocation ? form.dischargeLocation?.id : undefined,
				adjustmentAmount: form.adjustmentAmount,
				pjkTariff: form.referenceRateUnit === ReferenceRateUnit.Pjk ? form.pjkTariff : undefined,
				adjustmentType: form.adjustmentType,
				payableOver: form.payableOver,
				minimumQuantityPayable: form.minimumQuantityPayable,
				minimumPrice: form.minimumPrice,
			},
		}),
		toForm: (method) => ({
			referenceRateUnit: method.referenceRateUnit ?? undefined,
			referenceRateBase: method.referenceRateBase ?? undefined,
			referenceRateDateType: method.referenceRateDateType ?? undefined,
			route: method.route ?? undefined,
			loadLocation: method.loadLocation ?? undefined,
			dischargeLocation: method.dischargeLocation ?? undefined,
			adjustmentAmount: method.adjustmentAmount ?? undefined,
			adjustmentType: method.adjustmentType ?? undefined,
			pjkTariff: method.pjkTariff ?? undefined,
		}),
	},
};
